import { Feature, featureFlags } from 'config'

export const isFeatureEnabled = (key: Feature) => featureFlags[key]
